import { REQUEST_USER_REPORT_SUCCESS } from '../constants/actionTypes';

const INITIAL_STATE = {
  activeUserPercentage: 100,
  bannedUser: 0,
  graph: { },
  registeredMonth: 4,
  registeredToday: 3,
  registeredWeek: 3,
  registeredYear: 4,
  totalUser: 2
};

export default function userReport(state = INITIAL_STATE, action) {
  switch (action.type) {
    case REQUEST_USER_REPORT_SUCCESS:
      return {
        activeUserPercentage: action.payload.data.active_user_percentage || 0,
        bannedUser: action.payload.data.banned_user || 0,
        graph: action.payload.data.graph || {},
        registeredMonth: action.payload.data.registered_month || 0,
        registeredToday: action.payload.data.registered_today || 0,
        registeredWeek: action.payload.data.registered_week || 0,
        registeredYear: action.payload.data.registered_year || 0,
        totalUser: action.payload.data.total_user || 0
      };
    default:
      return state;
  }
}
